if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        this.productId = this.dataset.productId;
        this.limit = Number(this.dataset.limit || 3);
        this.currency = this.dataset.currency || 'USD';
        this.addLabel = this.dataset.addLabel || '+ Add';
        this.errorMessage = this.dataset.errorMessage || 'Could not add item. Please try again.';
        this.list = this.querySelector('[data-cart-recommendations-list]');
        this.error = this.querySelector('[data-cart-recommendations-error]');

        if (!this.productId || !this.list) {
          this.hidden = true;
          return;
        }

        this.loadRecommendations();
      }

      async loadRecommendations() {
        try {
          const routesRoot = window.Shopify?.routes?.root || '/';
          const url = `${routesRoot}recommendations/products.json?product_id=${encodeURIComponent(
            this.productId
          )}&limit=${this.limit}&intent=related`;
          const response = await fetch(url);
          if (!response.ok) throw new Error('Recommendations request failed');
          const data = await response.json();
          const products = Array.isArray(data.products) ? data.products.slice(0, this.limit) : [];

          if (!products.length) {
            this.hidden = true;
            return;
          }

          this.list.replaceChildren(...products.map((product) => this.createCard(product)));
          this.hidden = false;
        } catch (error) {
          this.hidden = true;
        }
      }

      createCard(product) {
        const variant = product.variants && product.variants[0];
        const card = document.createElement('article');
        card.className = 'cart-drawer-recommendations__card';

        const imageLink = document.createElement('a');
        imageLink.className = 'cart-drawer-recommendations__image-link';
        imageLink.href = product.url || '#';

        if (product.featured_image) {
          const image = document.createElement('img');
          image.className = 'cart-drawer-recommendations__image';
          image.src = this.getImageUrl(product.featured_image, 240);
          image.alt = product.title || '';
          image.loading = 'lazy';
          image.width = 120;
          image.height = 120;
          imageLink.append(image);
        }

        const body = document.createElement('div');
        body.className = 'cart-drawer-recommendations__body';

        const title = document.createElement('a');
        title.className = 'cart-drawer-recommendations__title';
        title.href = product.url || '#';
        title.textContent = product.title || '';

        const price = document.createElement('div');
        price.className = 'cart-drawer-recommendations__price';
        price.textContent = this.formatMoney(product.price || variant?.price || 0);

        body.append(title, price);

        const button = document.createElement('button');
        button.className = 'cart-drawer-recommendations__add';
        button.type = 'button';
        button.textContent = this.addLabel;
        button.disabled = !variant?.id || variant.available === false;
        button.addEventListener('click', () => this.addVariant(variant.id, button));

        card.append(imageLink, body, button);
        return card;
      }

      getImageUrl(image, width) {
        const source = typeof image === 'string' ? image : image.src;
        if (!source) return '';
        if (source.includes('width=')) return source;
        const separator = source.includes('?') ? '&' : '?';
        return `${source}${separator}width=${width}`;
      }

      formatMoney(cents) {
        const value = Number(cents || 0) / 100;

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.currency,
          }).format(value);
        } catch (error) {
          return `$${value.toFixed(2)}`;
        }
      }

      async addVariant(variantId, button) {
        if (!variantId || button.disabled) return;

        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = '...';
        this.hideError();

        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          if (cartDrawer) {
            formData.append(
              'sections',
              cartDrawer.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cartDrawer.setActiveElement(button);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(routes.cart_add_url, config);
          const state = await response.json();

          if (!response.ok || state.status) {
            throw new Error(state.description || this.errorMessage);
          }

          if (cartDrawer) {
            cartDrawer.renderContents(state);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cartData: state,
              productVariantId: variantId,
            });
          }
        } catch (error) {
          this.showError(error.message || this.errorMessage);
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      hideError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }
    }
  );
}
